export default __webpack_public_path__ + "static/kespa-mobile-a85e7817bf1a0289ebb8052e3a0ab884.mp4";